module.exports = __webpack_public_path__ + "static/media/数据分类器(调参过程).bd57672f.png";